module.exports = __webpack_public_path__ + "static/media/grafismo-trabalhe-conosco.9335bd67.svg";